
export const dataTab = {
    "query": {
        "id": "BANK_CARD_SALARY_REGISTRY_UI_V",
        "source": "BANK_CARD_SALARY_REGISTRY_UI_V",
        "context": "userFilialFilterContextStrategy",
        "fields": [
            {   "column": "id", },
            {   "column": "oper_day",  },
            {   "column": "card_code",  },
            {   "column": "code_filial",  },
            {   "column": "bxm_code", },
            {   "column": "client_id",  },
            {   "column": "contract_id",  },
            {   "column": "doc_number",  },
            {   "column": "doc_date", },
            {   "column": "doc_month", },
            {   "column": "doc_year", },
            {   "column": "currency", },
            {   "column": "mode", },
            {   "column": "filename", },
            {   "column": "register_amount", },
            {   "column": "balance_type_id", },
            {   "column": "created_at", },
            {   "column": "created_by", },
            {   "column": "modified_at", },
            {   "column": "modified_by", },
        ],
        "orderBy":[
            {
                "column":"id",
                "direction":"desc"
            }
        ],
    }
};

export const columns = (t) => [
    {
        title: t('id'),
        dataIndex: 'id',
        width: 60,
        sorter: (a, b) => a.id - b.id,
    },
    {
        title: t('oper_day'),
        dataIndex: 'oper_day',
        hidden: true,
        width: 60,
        sorter: (a, b) => new Date(a.oper_day) - new Date(b.oper_day),
    },
    {
        title: t('cardNumber'),
        dataIndex: 'card_code',
        width: 60,
        sorter: (a, b) => a.card_code - b.card_code,
    },
    {
        title: t('filial'),
        dataIndex: 'code_filial',
        width: 60,
        sorter: (a, b) => a.code_filial - b.code_filial,
    },
    {
        title: t('bxmCode'),
        dataIndex: 'bxm_code',
        width: 60,
        hidden: true,
        sorter: (a, b) => a.bxm_code - b.bxm_code,
    },
    {
        title: t('personId'),
        dataIndex: 'client_id',
        width: 60,
        sorter: (a, b) => a.client_id - b.client_id,
    },
    {
        title: t('contractId'),
        dataIndex: 'contract_id',
        width: 60,
        sorter: (a, b) => a.contract_id - b.contract_id,
    },
    {
        title: t('docNumb'),
        dataIndex: 'doc_number',
        width: 70,
        sorter: (a, b) => a.doc_number - b.doc_number,
    },
    {
        title: t('docDate'),
        dataIndex: 'doc_date',
        width: 100,
        sorter: (a, b) => new Date(a.doc_date.split('.').reverse().join('-')) - new Date(b.doc_date.split('.').reverse().join('-')),
    },
    {
        title: t('docMonth'),
        dataIndex: 'doc_month',
        width: 60,
        sorter: (a, b) => a.doc_month - b.doc_month,
    },
    {
        title: t('docYear'),
        dataIndex: 'doc_year',
        width: 60,
        sorter: (a, b) => a.doc_year - b.doc_year,
    },
    {
        title: t('currency'),
        dataIndex: 'currency',
        hidden: true,
        width: 60,
        sorter: (a, b) => a.currency?.localeCompare(b.currency),
    },
    {
        title: t('mode'),
        dataIndex: 'mode',
        hidden: true,
        width: 60,
        sorter: (a, b) => a.mode - b.mode,
    },
    {
        title: t('filename'),
        dataIndex: 'filename',
        hidden: true,
        width: 100,
        sorter: (a, b) => a.filename?.localeCompare(b.filename),
    },
    {
        title: t('registerAmount'),
        dataIndex: 'register_amount',
        width: 80,
        sorter: (a, b) => a.register_amount - b.register_amount,
    },
    {
        title: t('balanceTypeId'),
        dataIndex: 'balance_type_id',
        hidden: true,
        width: 60,
        sorter: (a, b) => a.balance_type_id - b.balance_type_id,
    },
    {
        title: t('createdDate'),
        dataIndex: 'created_at',
        hidden: true,
    },
    {
        title: t('createdBy'),
        dataIndex: 'created_by',
        hidden: true,
    },
    {
        title: t('modifiedDate'),
        dataIndex: 'modified_at',
        hidden: true,
    },
    {
        title: t('modifiedBy'),
        dataIndex: 'modified_by',
        hidden: true,
    },
];

export const dataFilter = [
    { "column": "id", "label": "ИД", "operator": "=", "datatype":"number"},
    { "column": "filial", "label": "Филиал", "operator": "in", "datatype":"text", "type":"M","typeRef":"FILIAL"},
    { "column": "card_account", "label": "Туловчи Х.Р.", "operator": "_like_", "datatype":"text"},
]

export const dataCardContractsTab = {
    "query": {
        "id": "BANK_CARD_PARENT_CONTRACTS_UI_V",
        "source": "BANK_CARD_PARENT_CONTRACTS_UI_V",
        "context": "userFilialFilterContextStrategy",
        "fields": [
            { "column": "id" },
            { "column": "mbat_filial" },
            { "column": "currency" },
            { "column": "contract_id" },
            { "column": "client_id" },
            { "column": "bxm_code" },
            { "column": "code_filial" },
            { "column": "file_name" },
            { "column": "account" },
        ],
        "orderBy": [
            {
                "column": "id",
                "direction": "desc"
            }
        ],
    }
};

export const columnsCardContracts = (t) => [
    {
        title: t('id'),
        dataIndex: 'id',
        width: 60,
        sorter: (a, b) => a.id - b.id,
    },
    {
        title: t('contractId'),
        dataIndex: 'contract_id',
        width: 60,
        sorter: (a, b) => a.contract_id - b.contract_id,
    },
    {
        title: t('filial'),
        dataIndex: 'mbat_filial',
        width: 60,
        sorter: (a, b) => a.mbat_filial - b.mbat_filial,
    },
    {
        title: t('bankAcc'),
        dataIndex: 'account',
        width: 60,
        sorter: (a, b) => a.account?.localeCompare(b.account),
    },
    {
        title: t('currency'),
        dataIndex: 'currency',
        width: 60,
        hidden: true,
        sorter: (a, b) => a.currency?.localeCompare(b.currency),
    },
    {
        title: t('clientId'),
        dataIndex: 'client_id',
        width: 60,
        hidden: true,
        sorter: (a, b) => a.client_id - b.client_id,
    },
    {
        title: t('bxmCode'),
        dataIndex: 'bxm_code',
        width: 60,
        hidden: true,
        sorter: (a, b) => a.bxm_code - b.bxm_code,
    },
    {
        title: t('filial'),
        dataIndex: 'code_filial',
        width: 60,
        hidden: true,
        sorter: (a, b) => a.code_filial - b.code_filial,
    },
];

export const dataCardContractsFilter = [
    { "column": "id", "label": "ИД", "operator": "=", "datatype":"number"},
    { "column": "mbat_filial", "label": "Филиал", "operator": "in", "datatype":"text", "type":"M","typeRef":"FILIAL"},
]

export const columnsCardWithContracts = (t) => [
    {
        title: t('embossedName'),
        dataIndex: 'embossed_name',
        width: 70,
        sorter: (a, b) => a.embossed_name?.localeCompare(b.embossed_name),
    },
    {
        title: t('cardNumber'),
        dataIndex: 'card_number',
        width: 70,
        sorter: (a, b) => a.card_number?.localeCompare(b.card_number),
        render: (_, record) => (
            record.card_number.replace(/(\d{4})(?=\d)/g,'$1 ')
        )
    },
    {
        title: t('dateExpire'),
        dataIndex: 'date_expire',
        width: 60,
        sorter: (a, b) => a.date_expire?.localeCompare(b.date_expire),
        render: (_, record) => {
            record.date_expire.replace(/(\d{2})(?=\d)/g, "$1/")
        }
    },
    {
        title: t('mbatId'),
        dataIndex: 'mbat_id',
        width: 60,
        hidden: true,
        sorter: (a, b) => a.mbat_id-b.mbat_id,
    },
    {
        title: t('clientId'),
        dataIndex: 'client_id',
        width: 60,
        hidden: true,
        sorter: (a, b) => a.client_id - b.client_id,
    },
    {
        title: t('contractId'),
        dataIndex: 'contract_id',
        width: 60,
        hidden: true,
        sorter: (a, b) => a.contract_id - b.contract_id,
    },
    {
        title: t('parentContractId'),
        dataIndex: 'parent_contract_id',
        hidden: true,
        width: 60,
        sorter: (a, b) => a.parent_contract_id - b.parent_contract_id,
    },

    {
        title: t('contractFilial'),
        dataIndex: 'contract_filial',
        hidden: true,
        width: 60,
        sorter: (a, b) => a.contract_filial?.localeCompare(b.contract_filial),
    },
    {
        title: t('cardFilial'),
        dataIndex: 'card_filial',
        hidden: true,
        width: 60,
        sorter: (a, b) => a.card_filial?.localeCompare(b.card_filial),
    },
    {
        title: t('currency'),
        dataIndex: 'currency',
        hidden: true,
        width: 60,
        sorter: (a, b) => a.currency?.localeCompare(b.currency),
    },

];

export const dataCardWithContractsTab = {
    "query": {
        "id": "BANK_CARDS_WITH_CONTRACTS_UI_V",
        "source": "BANK_CARDS_WITH_CONTRACTS_UI_V",
        "context": "userFilialFilterContextStrategy",
        "fields": [
            { "column": "embossed_name" },
            { "column": "client_uid" },
            { "column": "client_id" },
            { "column": "contract_id" },
            { "column": "parent_contract_id" },
            { "column": "card_number" },
            { "column": "contract_filial" },
            { "column": "card_filial" },
            { "column": "currency" },
            { "column": "mbat_id" },
            { "column": "date_expire" },
        ],
        "orderBy": [
            {
                "column": "client_id",
                "direction": "desc"
            }
        ],
    }
};